export default __webpack_public_path__ + "static/media/duplicateIcon.9123a112.svg";